import { render, staticRenderFns } from "./LabelInvoiceType.vue?vue&type=template&id=6782e3d7"
import script from "./LabelInvoiceType.vue?vue&type=script&lang=js"
export * from "./LabelInvoiceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports